import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { colors } from '../utils';
import MutedIllustration from '../assets/images/microphone-muted.svg';
import NotMutedIllustration from '../assets/images/microphone.svg';

const VolumeComponent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 160px;
  height: 35px;
  border-radius: 8px;
  background-color: ${colors.g01};
  margin-bottom: 20px;
`;

const Image = styled.img`
  height: 40px;
  width: 40px;
`;

class VolumeControl extends Component {
  constructor(props) {
    super(props);

    this.state = { isMuted: false };
    this.changeMutedStatus = this.changeMutedStatus.bind(this);
  }

  changeMutedStatus() {
    const { isMuted } = this.state;

    this.setState({ isMuted: !isMuted });
  }

  render() {
    const { onMuteClick } = this.props;
    const { isMuted } = this.state;
    const mutedImage = isMuted ? MutedIllustration : NotMutedIllustration;

    const onMuteClickHandler = async () => {
      try {
        await onMuteClick(isMuted);
      } catch (err) {
        return false;
      }

      return this.changeMutedStatus();
    };

    return (
      <VolumeComponent onClick={onMuteClickHandler}>
        <Image src={mutedImage} alt="Mute" />
      </VolumeComponent>
    );
  }
}

VolumeControl.defaultProps = {};

VolumeControl.propTypes = {
  onMuteClick: PropTypes.func.isRequired
};

export { VolumeControl };
